export default __webpack_public_path__ + "static/media/magazine(2).92f5b2e6.jpg";